import React from "react";
import { Link } from "react-router-dom";
import { NAV } from "@/constants/testIds";

const LOGO_SRC = "/assests/logo/HC_logo.png";

export function Logo({ compact = false, to = "/" }) {
  return (
    <Link
      data-testid={NAV.logo}
      to={to}
      className={`${compact ? "w-20 sm:w-28" : "w-24 sm:w-32 lg:w-36"} aspect-[1.87] flex shrink-0 items-center justify-center gap-2 group`}
      aria-label="Hyderabad Crackers home"
    >
      <img
        src={LOGO_SRC}
        alt="Hyderabad Crackers"
        className="block w-full h-full object-contain rounded-md"
        style={{ background: "#28292A" }}
      />
    </Link>
  );
}
